const overlaps = (boxes, x, y, width, height) => boxes.some(r =>
  Math.abs(x - r.x) < (width + r.width) / 2 + 3 && Math.abs(y - r.y) < height + 3);

/** Screen-sized measurements, projected using the same camera as the modules. */
export function drawClearanceGuides(ctx, guides, { project, W, H, isDark, locale = 'en-GB' }) {
  if (!guides?.length) return;
  ctx.save();
  ctx.font = '600 11px sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  const boxes = [];
  for (const guide of guides) {
    const a = project(guide.a), b = project(guide.b);
    if (![a.x, a.y, b.x, b.y, guide.distance].every(Number.isFinite)) continue;
    const colour = isDark ? '#7dd3fc' : '#075985';
    ctx.strokeStyle = colour;
    ctx.lineWidth = 1.4;
    ctx.setLineDash([5, 4]);
    ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
    ctx.setLineDash([]);
    const length = Math.hypot(b.x - a.x, b.y - a.y);
    const nx = length > 1e-6 ? -(b.y - a.y) / length : 1;
    const ny = length > 1e-6 ? (b.x - a.x) / length : 0;
    ctx.beginPath();
    for (const p of [a, b]) { ctx.moveTo(p.x - nx * 4, p.y - ny * 4); ctx.lineTo(p.x + nx * 4, p.y + ny * 4); }
    ctx.stroke();
    const el = locale.startsWith('el');
    const type = guide.kind === 'roof' ? (el ? 'Ακμή' : 'Edge') : (el ? 'Πάνελ' : 'Module');
    const name = guide.label || type;
    const number = guide.distance > 1e-8 && guide.distance < .01
      ? `<${(.01).toLocaleString(locale, { minimumFractionDigits: 2 })}`
      : guide.distance.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const text = `${number} m · ${name.length > 22 ? `${name.slice(0, 21)}…` : name}`;
    const width = (ctx.measureText?.(text)?.width || text.length * 6.5) + 12, height = 20;
    const x = Math.max(width / 2 + 3, Math.min(W - width / 2 - 3, (a.x + b.x) / 2));
    let y = Math.max(13, Math.min(H - 13, (a.y + b.y) / 2 - 14));
    for (let attempt = 0; attempt < 6 && overlaps(boxes, x, y, width, height); attempt++) {
      y = Math.max(13, Math.min(H - 13, y + (attempt % 2 ? 1 : -1) * (attempt + 1) * 23));
    }
    boxes.push({ x, y, width });
    ctx.fillStyle = isDark ? 'rgba(15,23,42,.94)' : 'rgba(255,255,255,.95)';
    ctx.fillRect(x - width / 2, y - height / 2, width, height);
    ctx.fillStyle = colour;
    ctx.fillText(text, x, y);
  }
  ctx.restore();
}
